


























































import { Component, Mixins } from 'vue-mixin-decorator';
import { Prop } from 'vue-property-decorator';
import { Invoice, Provider, Town } from '@/types/work/invoice';
import { CUSTOMERS_SHOW, OUTGOING_INVOICES_SHOW } from '@/router/work';
import Http from '@/Http';
import { DownloadFileMixin } from '@/mixins/DownloadFileMixin';
import AddCash from '@/components/work/invoices/AddCash.vue';
import AddDiscount from '@/components/work/invoices/AddDiscount.vue';
import ChangeProductReceive from '@/components/work/invoices/ChangeProductReceive.vue';

@Component({
  components: { ChangeProductReceive, AddDiscount, AddCash }
})
export default class InvoiceItem extends Mixins<DownloadFileMixin>(DownloadFileMixin) {
  @Prop() private invoice!: Invoice;

  public showAddCash = false;
  public showAddDiscount = false;
  public showChangeReceived = false;

  loadPDF:boolean = false;

  addedBalance () {
    this.showAddCash = false;
    this.$emit('updated');
  }

  setDiscount () {
    this.showAddDiscount = false;
    this.$emit('updated');
  }

  changeReceived () {
    this.showChangeReceived = false;
    this.$emit('updated');
  }

  public getReceivedColor () {
    let color: string = 'teal darken-1';
    if (this.invoice.products_received === true) {
      color = 'green';
    }
    if (this.invoice.products_received === false) {
      color = 'red';
    }
    return color;
  }

  get showInvoiceRoute () {
    return { name: OUTGOING_INVOICES_SHOW, params: { invoice: this.invoice.id } };
  }

  public getUserName () {
    return this.invoice.user_last_name + ' ' + this.invoice.user_name;
  }

  public getPaymentColor () {
    let result = this.invoice.obtained_cash - this.invoice.cash;
    if (result === 0 || result > 0) {
      return 'green';
    } else return 'blue-grey darken-4';
  }

  get customerRoute () {
    return { name: CUSTOMERS_SHOW, params: { customer: this.invoice.provider.id || 0 } };
  }

  public getProviderAddress () {
    const { provider } = this.invoice;
    let address = '';
    if (!provider) return;

    if (provider.data.enterprise) {
      address = provider.data.enterprise.street + ' ' + provider.data.enterprise.building;
    } else address = provider.address;

    return this.getProviderTown(provider.town) + ' ' + address;
  }

  public getProviderTown (town?:Town) {
    return town ? (town.district ? town.district + ' район, ' : '') + town.title : '';
  }

  public getPaymentText () {
    let result = this.invoice.obtained_cash - this.invoice.cash;
    if (result === 0) return this.$t('invoices.paid');
    if (result > 0) return this.$t('invoices.overpaid');
    return this.$t('invoices.not_paid');
  }

  downloadInvoice () {
    this.loadPDF = true;
    (new Http()).arrayBuffer({
      url: `enterprise/${this.invoice.from_enterprise_id}/invoices/outgoing/${this.invoice.id}/products/generate-excel`
    })
      .then((response:any) => {
        this.downloadFile(response);
        this.loadPDF = false;
        this.$emit('close');
      })
      .catch((e:any) => {
        this.loadPDF = false;
      });
  }
}
